import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(normal_header)/article/page/[pageNumber]/page.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Pagination/index.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/PostList/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/src/components/Sidebar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SideList"] */ "/vercel/path0/src/components/SideList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SnsLinks"] */ "/vercel/path0/src/components/SnsLinks/index.tsx");
